import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';

import {Modal} from "components/common/Modal";
import { MainButton } from 'components/common/MainButton';
import 'assets/sass/dashboard/common/BankChangeModal.scss';
import { featureFlags } from 'buenLib/communication/src';

const BankChangeModal = (props) => {
    const history = useHistory();
    const location = useLocation();

    const [showModal, setShowModal] = useState(false);

    const goToDeposit = () => {
        history.push('/dashboard/ingresar/ars');
        localStorage.setItem('showBankChangeModal', JSON.stringify(false));
    }

    useEffect(() => {
        if (!props.loading && location.pathname === '/dashboard' && featureFlags.getFlags().includes('coinag')) {
            const showBankChangeModal = JSON.parse(localStorage.getItem('showBankChangeModal'));
            if (showBankChangeModal === null) {
                setShowModal(true);
            } else {
                setShowModal(showBankChangeModal);
            }
        }
    }, [location.pathname, props.loading]);

    return (
        <Modal
            open={showModal}
            type={Modal.MODAL_TYPES.warning}
            title="¡Llegaron los ingresos y retiros inmediatos!"
            subtitle="Sumamos un nuevo banco para que tus pesos se acrediten al instante. Agendá nuestro nuevo CVU desde la sección Ingresar."
            canBeDismissed={false}
            className="totp-textfield"
        >
        <div className="modal-box">
            <div className="bank-change-modal-buttons">
                <MainButton
                    styleName="cta"
                    text="IR A INGRESAR"
                    onClick={goToDeposit}
                />
                <MainButton
                    data-action={Modal.CLOSE_MODAL_ACTION}
                    className="bank-change-dismiss-button"
                    styleName="tertiary"
                    text="EN OTRO MOMENTO"
                />
            </div>
        </div>
    </Modal>
    );
};

export default BankChangeModal;
